import { Maybe } from '@abstractTypes/graphqlTypes'
import { useStoreIndentity } from '@hooks/useStoreIdentity'
import { useRouteMatch } from 'react-router-dom'

export const useNextStepUrl = (nextStep: Maybe<string>) => {
  const { basePath } = useStoreIndentity()
  const match = useRouteMatch<{ stepId: string }>()
  return nextStep ? match.path.replace(':stepId', nextStep) : `${basePath}/frame-advisor/playlist`
}
